var _path, _g, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgKir = function SvgKir(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 450 300"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#CE1126",
    d: "M0 0h450v300H0V0z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#FCD116",
    stroke: "#BD9C08",
    strokeWidth: 1.2
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 225,
    cy: 150,
    r: 80
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225 16l-14.5 40h27zm62.6 17l-32.1 27.9L279 74zm-129.3.2l7.6 41.9 23.4-13.7zm175.1 40.9l-41 11.2 15.5 22zm-218.6-.9l24.2 35 15.6-22.1zm240.6 55.7l-41.7-8.1 4.2 26.6zm-262-1.2l37.6 19.8 3.7-26.8z"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#003F87",
    d: "M0 165h450v135H0V165z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M0 257c15 0 30 13 45 13s30-13 45-13 30 13 45 13 30-13 45-13 30 13 45 13 30-13 45-13 30 13 45 13 30-13 45-13 30 13 45 13 30-13 45-13v-21c-15 0-30 13-45 13s-30-13-45-13-30 13-45 13-30-13-45-13-30 13-45 13-30-13-45-13-30 13-45 13-30-13-45-13-30 13-45 13-30-13-45-13v21zm0-43c15 0 30 13 45 13s30-13 45-13 30 13 45 13 30-13 45-13 30 13 45 13 30-13 45-13 30 13 45 13 30-13 45-13 30 13 45 13 30-13 45-13v-21c-15 0-30 13-45 13s-30-13-45-13-30 13-45 13-30-13-45-13-30 13-45 13-30-13-45-13-30 13-45 13-30-13-45-13-30 13-45 13-30-13-45-13v21zm0-43c15 0 30 13 45 13s30-13 45-13 30 13 45 13 30-13 45-13 30 13 45 13 30-13 45-13 30 13 45 13 30-13 45-13 30 13 45 13 30-13 45-13v-21c-15 0-30 13-45 13s-30-13-45-13-30 13-45 13-30-13-45-13-30 13-45 13-30-13-45-13-30 13-45 13-30-13-45-13-30 13-45 13-30-13-45-13v21z"
  })));
};
export { SvgKir as ReactComponent };